<template>
  <svg id="duim" viewBox="-5 0 70 70">
    <path
      d="M58.4,31.2h-2.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c1.5,0,2.8,1.3,2.8,2.8c0,1.5-1.3,2.8-2.8,2.8
                        c0,0,0,0,0,0c-0.7,0-1.2,0.5-1.2,1.2l0,0c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0,0c1.5,0,2.8,1.3,2.8,2.8c0,1.5-1.3,2.8-2.8,2.8
                        c-0.6,0-1,0.4-1.1,0.9c0,0.1-0.1,0.2-0.1,0.3c0,0.7,0.5,1.2,1.2,1.2h0c1.5,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8H23.7V30.4l10-12.7V9
                        c0-1.4,1.2-2.6,2.6-2.6c2,0,3.8,1.4,4.2,3.3l1,4c0.4,1.5,0.4,3.1,0.1,4.6L40,25.6h18.2c0.1,0,0.1,0,0.2,0c1.5,0,2.8,1.3,2.8,2.8
                        C61.2,29.9,59.9,31.2,58.4,31.2 M21.3,58.6H3.1V30h18.2V58.6z M63.6,28.4c0-2.8-2.2-5.1-5-5.2c-0.1,0-0.2-0.1-0.3-0.1H43l0.9-4.3
                        c0.4-1.9,0.4-3.8-0.1-5.7l-1-4c-0.7-3-3.4-5.2-6.6-5.2c-2.8,0-5,2.2-5,5v7.9l-8.5,10.8H0.7V61h23v-3.5h32.6c2.9,0,5.2-2.3,5.2-5.2
                        c0-1.6-0.8-3-1.9-4c1.2-1,1.9-2.4,1.9-4c0-1.6-0.8-3-1.9-4c1.2-1,1.9-2.4,1.9-4c0-1.2-0.4-2.3-1.1-3.2
                        C62.3,32.4,63.6,30.5,63.6,28.4"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconDuim extends Vue {}
</script>
